import Modal from "./General/Modal";
import Input from "./General/Input";
import Button from "./General/Button";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { handleAuthModal, changeLoginRegisterToggler } from "../store/AuthSlice";
import { useFormik } from "formik";
import LoginRegisterSchema from "../validations/LoginRegister";
import Axios from "../utils/axios";
import helpers from "../utils/helpers";
import urls from "../constants/api-endpoints";
import accessToken from "../utils/access-token";
import { setUserDetails } from "../store/AuthSlice";
import { RegisterSchema, ResetPasswordSchema } from "../validations/LoginRegister";
import { setSnackBar } from "../store/ToastSlice";
import Select from "./General/Select";
import { useGoogleLogin } from "@react-oauth/google";
import { MixpanelTracking } from "../MixPanel";
import { MixPanelConstants } from "../constants/MixPanelEvents";

export default function LoginRegister( {themeClass} : any ) {
	const formStates = Object.freeze({
		LOGIN: {
			state: 1,
			text: 'Login'
		},
		REGISTER: {
			state: 2,
			text: 'Register'
		},
		CHOOSE_USER_TYPE : {
			state : 3,
			text : ''
		},
		RESET_PASSWORD : {
			state : 4,
			text : ''
		}
	});

	let initialValues : any = {
		name : '',
		phone : '',
		email: '',
		password: '',
		user_type: '',
		dial_code : {
			label : '+91',
			value : '+91'
		},
		profile : {
			company_name : '',
			is_manufacturer : false,
			is_trader : false,
			business_segments : []	
		}
	}

	// HOOKS
	const [formState, setFormState] = useState(formStates.LOGIN);
	const [currentSchema, setCurrentSchema] : any = useState(LoginRegisterSchema);
	const [sellerActive, setSellerActive] : any = useState(false);
	const [buyerActive, setBuyerActive] : any = useState(true);
	const [segments, setBusinessSegments] : any = useState([]);
	const [fromRegistrationForm, setFromRegistrationForm] : any = useState(true);
	const [googleLoginButtonDisabled, setGoogleLoginButtonDisabled] : any = useState(false);
	const [buttonLoader, setButtonLoader] : any = useState(false);

	const dispatch : any = useDispatch();
	const { authModal, showLoginRegisterToggler } = useSelector((state: any) => state.auth);
	const { countryList : {fixedList} } = useSelector((state : any) => state.core);
	const { values, errors, handleSubmit, handleBlur, handleChange, touched, resetForm, setFieldValue } = useFormik({
		initialValues: initialValues,
		validationSchema: currentSchema,

		onSubmit: (values, action) => {
			console.log(values);
			
			setButtonLoader(true);
			if(formState.state === 1)
				login(values, action.resetForm);
			else if(formState.state === 2) {
				if(!agreedWithTerms) {
					setShowError(true);
					return
				}
				setFormState(formStates.CHOOSE_USER_TYPE);
			}
			else
				getResetPasswordLink(values)
		}
	});

	useEffect(() => {
		getBusinessSegments();
	}, []);

	useEffect(() => {
	  setButtonLoader(false);
	}, [formState]);

	useEffect(() => {
		/** NOTE : This useEffect is temporarily written since there is no other use case of Sell on APIDrug Button
		 	In future, a global state for changing formstates may happen rather than this approach.
		 */
		if(!showLoginRegisterToggler) {
			setFormState(formStates.REGISTER)
			setBuyerActive(false);
			setSellerActive(true);
		}
	}, [showLoginRegisterToggler])

	// FUNCTIONS
	const getBusinessSegments = () => {
		const endPoint = helpers.getAPIEndpoint(urls.businessSegments);

		const successHandler = (response : any) => {
			if(response.status === 200) 
				setBusinessSegments(response.data);
		}

		const errorHandler = (error : any) => {
			console.log(error);
		}

		Axios.requestGET(
			endPoint,
			{},
			{},
			successHandler,
			errorHandler
		)
	}

	const changeFormState = (state: any) => {
		if(state.state === 1) {
			setCurrentSchema(LoginRegisterSchema);
		}
		else if(state.state === 2 || state.state === 3) {
			setCurrentSchema(RegisterSchema);
		}
		else {
			setCurrentSchema(ResetPasswordSchema);
		}
		setFormState(state);	
	}

	const handleClose = () => {
		dispatch(handleAuthModal(false));
		dispatch(changeLoginRegisterToggler(true));
		resetForm();
		setShowError(false);
		setFromRegistrationForm(true);
		setFormState(formStates.LOGIN)
		setCurrentSchema(LoginRegisterSchema)
	}

	const login = (data : object, resetCallback : Function) => {
		const mixPanelData = {
			action : MixPanelConstants.LOGGED_IN,
			actionType : MixPanelConstants.STANDARD,
		}

		const endPoint = helpers.getAPIEndpoint(urls.login);
		const successHandler = (response : any) => {

			const userDetails : any = helpers.decodeToken(response.data.access);
			
			MixpanelTracking.getInstance().identifyUser(userDetails.email);
			MixpanelTracking.getInstance().authFinished({
				...mixPanelData,
				status : MixPanelConstants.SUCCESS
			});

			setButtonLoader(false);
			if (response.status === 200) {
				accessToken.setCredentials(
					response.data.access,
					response.data.refresh,
					response.data.name
				);
				dispatch(setUserDetails({
					isLoggedIn: true,
					name: response.data.name
				}));
				handleClose();
				dispatch(setSnackBar(
                    {
                        color : 'success',
                        message : 'You have successfully signed in!'
                    }
                ));
			}
		}

		const errorHandler = (error : any) => {
			console.log(error.response.data);
			setButtonLoader(false);
			let message = ''
			try {
				message = error.response.data.message[0];
			}
			catch {
				message = error.response.data.detail;
			}
			dispatch(setSnackBar(
                {
                    color : 'error',
                    message : message
                }
            ));

			if(error.response.status === 400) {
				changeFormState(() => formStates.REGISTER)
			}

			MixpanelTracking.getInstance().authFinished({
				...mixPanelData,
				status : MixPanelConstants.FAILED
			})
		}

		Axios.requestPOST(
			endPoint,
			data,
			{},
			successHandler,
			errorHandler
		)
	}

	const fillBusinessSegmentsForPayload = (event : any) => {
		if(event.target.checked) {
			values.profile.business_segments.push(parseInt(event.target.value));
		}
		else {
			values.profile.business_segments = values.profile.business_segments.filter(
				(segment : any) => segment !== parseInt(event.target.value)
			);
		}
	}

	const register = () => {
		const payload = {...values}

		if(payload['phone'])
			payload['phone'] = `${payload['dial_code'].value}-${payload['phone']}`;
		
		delete payload['dial_code'];

		const mixPanelData = {
			action : MixPanelConstants.REGISTERED,
			actionType : MixPanelConstants.STANDARD,
		}

		/*  Setting user type in payload here. 
			Note : Commenting out sepecific user type for initial stage so that everyone can be buyer as well as seller.
		*/
		if(buyerActive && sellerActive)
			values.user_type = ''
		else if(buyerActive && !sellerActive)
			// values.user_type = 'customer'
			values.user_type = ''
		else
			// values.user_type = 'seller'
			values.user_type = ''
		
		setButtonLoader(true);
	
		const endPoint = helpers.getAPIEndpoint(urls.register)
		const successHandler = (response : any) => {
			setButtonLoader(false);
			if (response.status === 201) {
				accessToken.setCredentials(
                    response.data.token.access,
                    response.data.token.refresh,
                    response.data.name
                );
                dispatch(setUserDetails({
                    isLoggedIn : true,
                    name : response.data.name
                }));
                handleClose();
				dispatch(setSnackBar(
                    {
                        color : 'success',
                        message : 'You have successfully signed in!'
                    }
                ));
				setFormState(formStates.LOGIN);

				const userDetails : any = helpers.decodeToken(response.data.token.access);
			
				MixpanelTracking.getInstance().mapUserToGuestUser({
					email : userDetails.email,
					first_name : response.data.first_name,
					last_name : response.data.last_name,
				});
				MixpanelTracking.getInstance().authFinished({
					...mixPanelData,
					status : MixPanelConstants.SUCCESS
				});
			}
		}

		const errorHandler = (error : any) => {
			setButtonLoader(false);
			let message = '';
			try {
				message = error.response.data.message[0];
			}
			catch {
				message = error.response.data.detail;
			}
			dispatch(setSnackBar(
                {
                    color : 'error',
                    message : message
                }
            ));

			MixpanelTracking.getInstance().authFinished({
				...mixPanelData,
				status : MixPanelConstants.FAILED,
				reason : message
			});
		}

		Axios.requestPOST(
			endPoint,
			payload,
			{},
			successHandler,
			errorHandler
		)
	}

	// GOOGLE LOGIN
	const googleLoginOnSuccess = useGoogleLogin({
		flow : 'auth-code',
		onSuccess: async response => {
			const host = window.location.hostname;
			let redirectURI = ''

			if(host === 'localhost') {
				redirectURI = `http://${window.location.host}`
			}
			else {
				redirectURI = `https://${window.location.host}`
			}

			const payload = {
				authorization_code : response.code,
				redirect_uri : redirectURI
			}
			socialLogin(payload)
		}
	});

	const socialLogin = (payload : object) => {
		const mixPanelData = {
			actionType : MixPanelConstants.GOOGLE_LOGIN,
		}

		const endPoint = helpers.getAPIEndpoint(urls.googleLogin)
		setGoogleLoginButtonDisabled(true);

		const successHandler = (response : any) => {
			// In case the user is already registered login the user from frontend.
			if(response.data.registered) {
				accessToken.setCredentials(
					response.data.token.access,
					response.data.token.refresh,
					response.data.name
				);
				dispatch(setUserDetails({
					isLoggedIn : true,
					name : response.data.name
				}));
				dispatch(handleAuthModal(false));
				dispatch(setSnackBar(
					{
						color : 'success',
						message : 'You have successfully signed in!'
					}
				));
				
				const userDetails : any = helpers.decodeToken(response.data.token.access);
	
				MixpanelTracking.getInstance().identifyUser(userDetails.email);
				MixpanelTracking.getInstance().authFinished({
					...mixPanelData,
					action : MixPanelConstants.LOGGED_IN,
					actionType : MixPanelConstants.GOOGLE_LOGIN,
					status : MixPanelConstants.SUCCESS
				});
			}
			// In case the user is not registered, redirect to business segment popup.
			else {
				setFromRegistrationForm(false);
				setFormState(formStates.CHOOSE_USER_TYPE);
				values['user_id'] = response.data.id;
			}
			setGoogleLoginButtonDisabled(false);
		}

		const errorHandler = (error : any) => {
			console.log(error);
			setGoogleLoginButtonDisabled(false);
			dispatch(setSnackBar(
				{
					color : 'error',
					message : 'Something went wrong while logging with Google. Please try again!'
				}
			));

			MixpanelTracking.getInstance().authFinished({
				...mixPanelData,
				actionType : MixPanelConstants.GOOGLE_LOGIN,
				status : MixPanelConstants.FAILED
			})
		}

		Axios.requestPOST(
			endPoint,
			payload,
			{},
			successHandler,
			errorHandler
		)
	}

	const createProfileAndLogin = () => {
		const endPoint = helpers.getAPIEndpoint(urls.createProfile);
		
		/*  Setting user type in payload here. 
			Note : Commenting out sepecific user type for initial stage so that everyone can be buyer as well as seller.
		*/
		if(buyerActive && sellerActive)
			values.user_type = ''
		else if(buyerActive && !sellerActive)
			// values.user_type = 'customer'
			values.user_type = ''
		else
			// values.user_type = 'seller'
			values.user_type = ''

		const payload = {user : values.user_id, user_type : values.user_type, ...values.profile}

		setButtonLoader(true);

		const successHandler = (response : any) => {
			setButtonLoader(false);
			accessToken.setCredentials(
				response.data.token.access,
				response.data.token.refresh,
				response.data.user_details.name
			);
			dispatch(setUserDetails({
				isLoggedIn : true,
				name : response.data.user_details.name
			}));
			handleClose();
			dispatch(setSnackBar(
				{
					color : 'success',
					message : 'You have successfully signed in!'
				}
			));
			
			const decodedToken : any = helpers.decodeToken(response.data.token.access)
			MixpanelTracking.getInstance().mapUserToGuestUser({
				email : decodedToken.email,
				first_name : response.data.user_details.first_name,
				last_name : response.data.user_details.last_name,
			});
			MixpanelTracking.getInstance().authFinished({
				action : MixPanelConstants.REGISTERED,
				actionType : MixPanelConstants.GOOGLE_LOGIN,
				status : MixPanelConstants.SUCCESS
			});
		}

		const errorHandler = (error : any) => {
			setButtonLoader(false);
			console.log(error);

			MixpanelTracking.getInstance().authFinished({
				action : MixPanelConstants.REGISTERED,
				actionType : MixPanelConstants.GOOGLE_LOGIN,
				status : MixPanelConstants.FAILED
			});
		}

		Axios.requestPOST(
			endPoint,
			payload,
			{},
			successHandler,
			errorHandler
		)
	}

	const [agreedWithTerms, setAgreedWithTerms] = useState(false);
	const [showError, setShowError] = useState(false);
	const handleTerms = (e : any) => {
		console.log(e.target.checked);
		setShowError(false);
		setAgreedWithTerms(e.target.checked);
	}

	const [resetPasswordBackendMessage, setResetPasswordBackendMessage] = useState('');
	const getResetPasswordLink = (payload : any) => {
		const endPoint = helpers.getAPIEndpoint(urls.getResetPasswordLink);

		const successHandler = (response : any) => {
			setResetPasswordBackendMessage(response.data.detail);
			resetForm();
		}

		const errorHandler = (error : any) => {
			console.log(error);
			dispatch(setSnackBar(
				{
					color : 'error',
					message : error.response.data.detail[0]
				}
			));
		}

		Axios.requestPOST(
			endPoint,
			payload,
			{},
			successHandler,
			errorHandler
		)
	}

	return (
		<>
			<Modal styles='w-[90%] lg:w-[32%]' show={authModal}>
				{
					(formState.state !== 4) && 
					(
						(formState.state === 1 || formState.state === 2) ?
						<div className="pt-5 pb-2 lg:pb-6 h-[92vh] overflow-y-auto">
							<div className="close flex justify-end pr-3">
								<svg onClick={handleClose} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 cursor-pointer">
									<path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
								</svg>
							</div>
							
							{
								showLoginRegisterToggler && 
								<div className="px-12 tabs flex justify-center items-center -translate-y-2">
									<h3
										className={`py-2 text-xl w-1/2 h-[50px] text-center cursor-pointer font-light ${formState.state === 1 ? `border-b-4 border-${themeClass}` : 'opacity-50'}`}
										onClick={() => changeFormState(formStates.LOGIN)}
									>
										Login
									</h3>
									<div className="w-[0.8px] h-6 bg-theme-black opacity-40 mx-2"></div>
									<h3
										className={`py-2 text-xl w-1/2 h-[50px] text-center cursor-pointer font-light ${formState.state === 2 ? `border-b-4 border-${themeClass}` : 'opacity-50'}`}
										onClick={() => changeFormState(formStates.REGISTER)}
									>
										Register
									</h3>
								</div>
							}

							<div className="pt-2 lg:pt-4 px-6 lg:px-12">
								<form onSubmit={handleSubmit}>
									{
										formState.state === 2 &&
										<div>
											<div>
												<Input
													label='Your Name'
													labelColor='#444444'
													labelProperties='opacity-50 text-[15px]'
													placeholder='Enter Name'
													properties='border border-[#707070 50%] rounded h-11 placeholder:text-sm'
													onChange={handleChange}
													name='name'
													value={values.name}
													onBlur={handleBlur}
													error={errors.name}
													touched={touched.name}
												/>
											</div>

											<div className="pt-4">
												<Input
													label='Company Name'
													labelColor='#444444'
													labelProperties='opacity-50 text-[15px]'
													placeholder='Enter Company Name'
													properties='border border-[#707070 50%] rounded h-11 placeholder:text-sm'
													onChange={handleChange}
													name='profile.company_name'
													value={values.profile.company_name}
													onBlur={handleBlur}
												/>
											</div>
										</div>
									}

									{
										formState.state === 2 &&
										<div className="pt-4">
											<label className="text-theme-black opacity-50 text-[15px]"> Phone </label>
											<div className="flex justify-between items-start">
												<div style={{ width : '25%' }}>
													<Select
														search
														suffix = {
															<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
																<path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
															</svg>
														}
														placeholder = '+XX'
														items = {fixedList}
														defaultValue = {values.dial_code}
														value = {values.dial_code}
														additionalStyles = {{
															padding : '2.4px 3px',
														}}
														selectedColor = 'gray'
														placeholderStyles = {{
															fontSize : 13,
															fontWeight : 300
														}}
														onChange = {(selected : any) => setFieldValue('dial_code', selected)}
													/>
												</div>

												<div style={{ width : '75%' }}>
													<Input
														labelColor='#444444'
														labelProperties='opacity-50'
														placeholder='Enter Phone'
														properties='border border-[#707070 50%] rounded h-11 placeholder:text-sm'
														outerProperties = 'pl-2 w-full'
														onChange={handleChange}
														name='phone'
														value={values.phone}
														onBlur={handleBlur}
														error={errors.phone}
														touched={touched.phone}
														maxLength = {10}
													/>
												</div>
											</div>
										</div>
									}

									<div className="pt-4">
										<Input
											type='email'
											label='Email'
											labelColor='#444444'
											labelProperties='opacity-50 text-[15px]'
											placeholder='Enter Email'
											properties='border border-[#707070 50%] rounded h-11 placeholder:text-sm'
											onChange={handleChange}
											name='email'
											value={values.email}
											onBlur={handleBlur}
											error={errors.email}
											touched={touched.email}
										/>
									</div>

									<div className={`${formState.state === 1 ? 'pt-10' : 'pt-4'}`}>
										<Input
											type='password'
											label='Password'
											labelColor='#444444'
											labelProperties='opacity-50 text-[15px]'
											placeholder='Enter Password'
											properties='border border-[#707070 50%] rounded h-11 placeholder:text-sm'
											onChange={handleChange}
											name='password'
											value={values.password}
											onBlur={handleBlur}
											error={errors.password}
											touched={touched.password}
										/>
									</div>

									{formState.state === 1 &&
										<div className="flex justify-end pt-4">
											<small 
												className={`cursor-pointer text-${themeClass} font-light`}
												onClick={() => changeFormState(formStates.RESET_PASSWORD)}>
													Forgot Password?
											</small>
										</div>
									}

									<div>
										{
											formState.state === 2 &&
											<div>
												<small className="block text-xs text-theme-black opacity-80 mt-4">
													<input type="checkbox" name="" id="" className="mr-2 accent-theme-orange" onChange={handleTerms} />
													I agree with
													<span className={`text-${themeClass} cursor-pointer`}> 
														<a href="https://apidrug.s3.amazonaws.com/media/APIdrug_terms_of_service.pdf" target="_blank">
															{` Terms of service`}
														</a>
													</span>
												</small>
												{
													showError && 
													<small className="text-error">This is a required field</small>
												}
											</div>
											
										}

										<Button
											loader = {buttonLoader}
											type = "submit"
											styles={`bg-${themeClass} text-white w-full h-12 ${formState.state === 1 ? 'mt-12' : 'mt-[25px]'}`}
										>
											{formState.text}
										</Button>
									</div>
								</form>

								{/* <div className={`flex justify-center items-center ${formState.state === 1 ? 'my-10' : 'my-2 lg:my-4'}`}>
									<div className="h-[0.8px] w-full bg-theme-black opacity-10"></div>
									<div className="mx-2 text-theme-black opacity-80 font-light text-sm">or</div>
									<div className="h-[0.8px] w-full bg-theme-black opacity-10"></div>
								</div> */}

								{/* <Button disabled = {googleLoginButtonDisabled} styles={`border border-${themeClass} flex justify-center items-center w-full h-12`} onClick={googleLoginOnSuccess}>
									<span className="pr-2"><img src="/Google.svg" alt="G" width={20} height={20} /></span>
									{ !googleLoginButtonDisabled ? formState.text + ' with Google' : 'Please Wait...' }
								</Button> */}

								<div className="mt-3">
									<small>
										{formState.state === 1 ? 'Not a member' : 'Already have an account?' }
										<span onClick={() => formState.state === 1 ? changeFormState(formStates.REGISTER) : changeFormState(formStates.LOGIN)} className="cursor-pointer" style={{ color: '#022E92' }}>
											{formState.state === 1 ? ' Register' : ' Login' }
										</span>
									</small>
								</div>
							</div>
						</div> 
						
						: 

						<div className="relative userType pt-5 pb-6 h-[90vh] overflow-y-auto px-10">
							<div className={`flex justify-between items-center ${fromRegistrationForm ? 'justify-between' : 'justify-end'}`}>
								{
									fromRegistrationForm && 
									<svg onClick={() => setFormState(formStates.REGISTER)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 cursor-pointer">
										<path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
									</svg>
								}

								<svg onClick={handleClose} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 cursor-pointer">
									<path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
								</svg>
							</div>

							<div className="flex justify-between mt-10">
								<div onClick={() => setBuyerActive(!buyerActive)} className={`relative rounded-[8px] w-[48%] text-center border cursor-pointer py-2 text-[15px] select-none ${buyerActive && 'border-theme-orange shadow-xl'}`}>
									Become a Buyer
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={`w-6 h-6 absolute -top-4 -right-3 ${buyerActive ? 'text-theme-orange' : 'text-[#DADADA]'}`}>
										<path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
									</svg>
								</div>
								<div onClick={() => setSellerActive(!sellerActive)} className={`relative rounded-[8px] w-[48%] text-center border cursor-pointer py-2 text-[15px] select-none ${sellerActive && 'border-theme-orange shadow-xl'}`}>
									Become a Seller
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={`w-6 h-6 absolute -top-4 -right-3 ${sellerActive ? 'text-theme-orange' : 'text-[#DADADA]'}`}>
										<path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
									</svg>
								</div>
							</div>

							<div className="image-section flex justify-center items-center h-[120px] mt-8">
								<img src="/Register.png" alt="" className="w-[80%] h-[100%]" />
							</div>

							<div className="bg-[#EBEBEB7C] absolute w-full left-0 py-2 flex justify-center items-center">
								<div className="mx-2">
									<input 
										id="trading-input" 
										type="checkbox" 
										className="inline-block w-[18px] h-[18px] mr-3 accent-theme-orange" 
										onChange={(event) => values.profile.is_trader = event.target.checked}
									/>
									<label htmlFor="trading-input" className="cursor-pointer select-none text-[15px]">Trading</label>
								</div>
								<div className="mx-2">
									<input 
										id="manufacturing-input" 
										type="checkbox" 
										className="inline-block w-[18px] h-[18px] mr-3 accent-theme-orange" 
										onChange={(event) => values.profile.is_manufacturer = event.target.checked}
									/>
									<label htmlFor="manufacturing-input" className="cursor-pointer select-none text-[15px]">Manufacturing</label>
								</div>
							</div>

							<div className="mt-[70px] grid grid-rows-5 grid-flow-col justify-items-left items-center gap-x-1">
								{
									segments.map((data : any, index : any) => (
										<div className="flex justify-left items-center" key={data.id}>
											<input 
												onChange={fillBusinessSegmentsForPayload} 
												type="checkbox" 
												id={`material-${index}`} 
												className="h-[17px] w-[17px] mr-3 block accent-theme-orange" 
												value={data.id} 
											/>
											<label className="text-sm cursor-pointer" htmlFor={`material-${index}`}> {data.name} </label>
										</div>
									))
								}
							</div>

							<Button
								loader = {buttonLoader}
								onClick = {fromRegistrationForm ? register : createProfileAndLogin}
								styles={`bg-${themeClass} text-white w-full h-12 ${formState.state === 1 ? 'mt-10' : 'mt-[25px]'}`}
							>
								Submit
							</Button>
						</div>
					)
					
				}

				{
					formState.state === 4 &&
					<div className="flex pt-5 pb-6 h-[40vh] overflow-y-auto px-10">
						<div className="w-full">
							<form onSubmit={handleSubmit}>
								<div className="pt-4">
									<Input
										type='email'
										label='Email'
										labelColor='#444444'
										labelProperties='opacity-50 text-[15px]'
										placeholder='Enter Email'
										properties='border border-[#707070 50%] rounded h-11 placeholder:text-sm'
										onChange={handleChange}
										name='email'
										value={values.email}
										onBlur={handleBlur}
										error={errors.email}
										touched={touched.email}
									/>
								</div>
								<Button

									styles={`bg-${themeClass} text-white w-full h-12 mt-10`}
								>
									Send Password Reset Email
								</Button>
							</form>
							{
								resetPasswordBackendMessage && 
								<small className="text-[#429F39] text-[11px] mt-3 w-[100%] block"> {resetPasswordBackendMessage} </small>
							}
							<div className="flex justify-end pt-4">
								<small 
									className={`cursor-pointer text-${themeClass} font-light`}
									onClick={() => changeFormState(formStates.LOGIN)}>
										Back to Login
								</small>
							</div>
						</div>
					</div>
				}
			
			</Modal>
		</>
	);
}

LoginRegister.defaultProps = {
	themeClass : 'theme-orange'
}
